import { useContent } from "@/context/ContentProvider";
import { Link } from "react-router-dom";

const CONTACT_URL = "mailto:info@mayr-technologies.com";

const FALLBACK = {
  company_name: "Mayr Technologies",
  email: "info@mayr-technologies.com",
};

const LEGAL_LINKS = [
  { label: "Support", to: "/support" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
];

const Footer = () => {
  const { data } = useContent("footer");
  const footer = data || FALLBACK;

  return (
    <footer
      data-testid="footer"
      className="border-t border-white/[0.06] py-12 px-6 md:px-8"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <img src="/mayr-logo-transparent.png?v=6" alt="Mayr Technologies" className="h-[56px] w-auto object-contain" />
        </div>
        <div className="flex flex-col items-start md:items-end gap-3">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            {LEGAL_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-xs text-neutral-600 font-['Manrope'] tracking-wide transition-colors duration-300 hover:text-neutral-400"
              >
                {link.label}
              </Link>
            ))}
          </div>
          <div className="flex items-center gap-6">
            <a
              href={CONTACT_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-email"
              className="text-xs text-neutral-600 font-['Manrope'] tracking-wide
                transition-colors duration-300 hover:text-neutral-400"
            >
              {footer.email}
            </a>
            <span className="text-xs text-neutral-700 font-['Manrope']">
              &copy; {new Date().getFullYear()}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
